import { resetButtonStylingCSS } from '@tmh-website/styles/global';
import StyledTypo from '@tmh-website/styles/typo';
import { FormElementThemeColor, formElementThemes } from '@tmh-website/ui/FormElements';
import styled from 'styled-components';

export const Button = styled.button<{ $themeColor: FormElementThemeColor }>`
  ${resetButtonStylingCSS};
  ${StyledTypo.copyCss};
  display: flex;
  gap: 4px;
  align-items: center;
  font-weight: ${props => props.theme.fontWeight.bold};
  color: ${props => props.theme.color[formElementThemes[props.$themeColor].text]};
`;

export const Container = styled.div`
  display: flex;
  gap: ${props => props.theme.gap.xSmall};
  align-items: center;
  padding-left: 8px;
`;
